import Accordion from './accordion';
import AudioPlayer from './audio-player';
import BlogFeed from './blog-feed';
import BlogGrid from './blog-grid';
import BlogList from './blog-list';
import BlogPost from './blog-post';
import Button from './button';
import BuyButton from './buy-button';
import CardsGeneral from './cards-general';
import CardsTall from './cards-tall';
import CardsWide from './cards-wide';
import CardsEvent from './cards-event';
import CardsStep from './cards-step';
import Carousel from './carousel';
import CodeGeneral from './code-general';
import Columns from './columns';
import ContentSlider from './content-slider';
import Copyright from './copyright';
import Countdown from './countdown';
import Divider from './divider';
import Form from './form';
import Grid from './grid';
import GroupGrid from './group-grid';
import GroupItem from './group-item';
import GroupList from './group-list';
import Header from './header';
import ImageGallery from './image-gallery';
import ImageGeneral from './image-general';
import GoogleMap from './google-map';
import SectionBlock from './section';
import AudioSeries from './audio-series';
import ServiceCountdown from './service-countdown';
import SocialMedia from './social-media';
import FooterNav from './footer-nav';
import Table from './table';
import Tabs from './tabs';
import TextBlob from './text-blob';
import TextGeneral from './text-general';
import TextSwapper from './text-swapper';
import VideoPlayer from './video-player';
import VideoSeries from './video-series';
import YouTubeVideo from './youtube-video';
import MediaItem from './media-item';
import MediaItemGrid from './media-item-grid';
import MediaItemFeed from './media-item-feed';
import MediaItemList from './media-item-list';
import MenuGrid from './menu-grid';
import Modal from './modal';
import Navigation from './navigation';
import ListMenu from './list-menu';
import PdfMenu from './pdf-menu';
import PlaceCards from './place-cards';
import PlaceDetails from './place-details';
import PlaceFeed from './place-feed';
import PlaceGrid from './place-grid';
import ProductCard from './product-card';
import ProductFeature from './product-feature';
import ProductFeed from './product-feed';
import ProductGrid from './product-grid';
import ProjectCards from './project-cards';
import ProjectFeed from './project-feed';
import ProjectDetails from './project-details';
import ProjectGrid from './project-grid';
import ProfileCards from './profile-cards';
import ProfileFeed from './profile-feed';
import ProfileGrid from './profile-grid';
import ProfileDetails from './profile-details';
import ProgressBar from './progress-bar';

export const allDroplets = {
  Accordion,
  AudioPlayer,
  AudioSeries,
  BlogFeed,
  BlogGrid,
  BlogList,
  BlogPost,
  Button,
  BuyButton,
  CardsGeneral,
  CardsTall,
  CardsWide,
  CardsEvent,
  CardsStep,
  Carousel,
  CodeGeneral,
  Columns,
  ContentSlider,
  Copyright,
  Countdown,
  Divider,
  Form,
  Grid,
  GroupGrid,
  GroupItem,
  GroupList,
  Header,
  ImageGallery,
  ImageGeneral,
  GoogleMap,
  SectionBlock,
  ServiceCountdown,
  SocialMedia,
  FooterNav,
  Table,
  Tabs,
  TextBlob,
  TextGeneral,
  TextSwapper,
  VideoPlayer,
  VideoSeries,
  YouTubeVideo,
  MediaItem,
  MediaItemGrid,
  MediaItemFeed,
  MediaItemList,
  MenuGrid,
  Modal,
  Navigation,
  ListMenu,
  PdfMenu,
  ProductCard,
  ProductFeature,
  ProductFeed,
  ProductGrid,
  ProjectCards,
  ProjectFeed,
  ProjectDetails,
  ProjectGrid,
  ProfileCards,
  ProfileFeed,
  ProfileGrid,
  ProfileDetails,
  PlaceDetails,
  PlaceGrid,
  PlaceCards,
  PlaceFeed,
  ProgressBar,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/all-droplets.js